import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  SendFullStressNotificationData,
  ActionType,
} from "models/stressCheck/fullStressSendNotification";
import { IResponse } from "models";
import { httpStatus } from "configs/httpStatus";
import { sendFullStressNotification } from "services/stressCheck";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./fullStressSendNotiActions";

function* sendFullStressNotificationSaga({
  payload,
}: {
  payload: SendFullStressNotificationData;
}) {
  try {
    const response: IResponse = yield call(sendFullStressNotification, payload);

    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else if (response.status === httpStatus.StatusUnauthorized) {
      yield put(handleErrorAction(response.message || ""));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onSendFullStressNotificationWatcher() {
  yield takeLatest(
    ActionType.SEND_FULL_NOTIFICATION as any,
    sendFullStressNotificationSaga
  );
}

export default [fork(onSendFullStressNotificationWatcher)];
